import * as React from 'react';
import { __, mapStateToProps, validateForm } from '../core/utils';
import { setNotification } from '../redux/actions/general/notification';
import { createProjectPlanningTemplate } from '../redux/actions/table/stages';
import PlanningTemplateForm from '../forms/planning_template/PlanningTemplateForm';
import AddTemplateIcon from '../assets/images/add-boq-template-group-60x60.svg';
import styles from '../styles/wizards/PlanningTemplateWizard.scss';

const AddProjectPlanningTemplateWizard = ({ languageId, onClose, wizard }) => {
  const handleSubmit = (formData) =>
    validateForm(
      createProjectPlanningTemplate(wizard.project_id, {
        ...formData,
        selected_rows: wizard.selected_rows,
      }).then(() => {
        setNotification(__('planning-templates.template.saved'));
        onClose();
      }),
    );

  return (
    <div className={styles.templateFormWizard}>
      <header className={styles.v3WizardHeader}>
        <div>
          <strong>
            {__('planning-templates.template.save-title')}
          </strong>
          <span>
            {__('planning-templates.template.save-subtitle')}
          </span>
        </div>
        <AddTemplateIcon />
      </header>
      <div className={styles.v3WizardBody}>
        <PlanningTemplateForm
          initialValues={{
            name: { [languageId]: '' },
            description: {},
            active: 1,
          }}
          onClose={onClose}
          onSubmit={handleSubmit}
        />
      </div>
    </div>
  );
};

export default mapStateToProps((state) => ({
  languageId: state.auth.language_id,
  wizard: state.table.stages.save_project_planning_as_template,
}))(AddProjectPlanningTemplateWizard);
